export const fetchSettingsData = () => {
    return {
        type: 'FETCH_SETTINGS_DATA'
    }
}